import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **SearchEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a las busquedas.
 */
export class SearchEndpoint {
  /** Endpoint que retorna una todos los geomarcadores que existen en el back y que se encuentren activos*/
  public static search = `${apiUrl}search/`;
  /** Endpoint que retorna una lista de geomarcadores aleatorios*/
  public static searchRandom = `${apiUrl}search/random/`;
  /** Endpoint que retorna una todos los geomarcadores que existen en el back, que se encuentren activos y que pueden ubicarse en el mapa*/
  public static searchMap = `${apiUrl}search/map/`;
}
